import React from 'react';
import AppRouter from '../router/router';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

const App = () => {
  return (
      <AppRouter />
  );
};

export default App;
